module.exports = __webpack_public_path__ + "img/mariana.24a15a82.png";